<template>
  <v-dialog
  persistent
    v-model="dialog"
    :content-class="isDarkMode ? 'dark-mode' : ''"
    width="fit-content"
  >
    <v-card>
      <v-card-title class="bg-grey fs-1-5r">
        <span tabindex="0">{{ $t('Dynamic Fields') }}</span>
      </v-card-title>
      <div class="bg-white font-size-16 pa-4" tabindex="0">
        <div
          v-if="interfaceDynamicFields.length === 0 || interfaceDynamicFields.filter(
            el => el.textToDisplay != 'Static Path'
          ).length === 0"
          class="wrapper-1 bg-white"
          :class="[language === 'he' ? 'dir-rtl' : 'dir-ltr']"
        >
          <v-card-title class="text-h5 bg-grey">{{
            $t('No Dynamic Fields to Display')
          }}</v-card-title>
        </div>
        <div v-else :class="[language === 'he' ? 'dir-rtl' : 'dir-ltr']">
          <!--TITLE-SUBJECT-->
          <p
          class="font-size-16"
            v-for="item of interfaceDynamicFields.filter(
              el => el.textToDisplay != 'Static Path' && el.value
            )"
          >
            <b>{{ item.textToDisplay }}:</b>
            <span class="mx-2 word-break">{{ item.value }}</span>
          </p>
        </div>
      </div>
      <v-divider />
      <v-card-actions class="d-flex justify-end">
        <Button
          :clickAction="closeDynamicFieldsDialog"
          text="Close"
          btnType="grey"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SubjectMessageDialog',
  data() {
    return {
      dialog: true,
    }
  },
  props: {
    closeDynamicFieldsDialog: Function,
    interfaceDynamicFields: Array,
  },
  components: { Button },

  computed: {
    ...mapGetters(['isDarkMode', 'language']),
  },
}
</script>
